import { useReveal } from '../hooks/useReveal';
import { useBloco, urlWhatsapp } from '../content';

export default function Aquicultura() {
  const leftRef = useReveal();
  const rightRef = useReveal();
  const c = useBloco('home.aquicultura');

  return (
    <section className="feature" id="aquicultura">
      <div className="feat-text reveal" ref={leftRef}>
        <div className="lbl">{c.eyebrow}</div>
        <h3>{c.heading} <em>{c.headingEm}</em> {c.headingAfter}</h3>
        <p>{c.paragraph1}</p>
        <p>{c.paragraph2}</p>
        <a
          href={urlWhatsapp('comercial')}
          target="_blank" rel="noopener noreferrer"
          className="btn-primary mt-4 d-inline-flex"
          style={{ marginTop: 20 }}
        >
          <span>{c.cta}</span>
        </a>
      </div>

      <div className="feat-visual reveal" ref={rightRef}>
        <div className="feat-badge b1">
          <div className="ic">{c.badge1.icon}</div>
          <div>
            <div className="t">{c.badge1.title}</div>
            <div className="v">{c.badge1.value}</div>
          </div>
        </div>
        <div className="feat-badge feat-badge-2 b2">
          <div className="ic" style={{ background: 'linear-gradient(135deg,var(--ocean),var(--deep))' }}>{c.badge2.icon}</div>
          <div>
            <div className="t">{c.badge2.title}</div>
            <div className="v">{c.badge2.value}</div>
          </div>
        </div>
        <div className="feat-blob-wrap">
          <img
            src={`${process.env.PUBLIC_URL}${c.image}`}
            alt={c.imageAlt}
            loading="lazy"
            decoding="async"
          />
        </div>
      </div>
    </section>
  );
}